import type { FunctionComponent, ReactNode } from 'react'
import React, { PureComponent } from 'react'

import Divider from '@vfuk/core-divider'
import { getDataSelector } from '@vfuk/core-base-props'

import * as Styled from './styles/OverflowMenuItem.style'

import type { OverflowMenuItemProps } from './OverflowMenuItem.types'

class OverflowMenuItem extends PureComponent<OverflowMenuItemProps> {
  public static defaultProps: Partial<OverflowMenuItemProps> = {
    disabled: false,
    focused: false,
    active: false,
  }

  private checkIsIcon = (): boolean => {
    if (!this.props.children) return false

    const component = this.props.children?.type as FunctionComponent
    const displayName = component?.displayName

    return displayName ? displayName.includes('Icon') : false
  }

  public render(): ReactNode {
    return (
      <Styled.OverflowMenuItem
        id={this.props.value}
        role='option'
        aria-label={this.props.srText}
        aria-selected={this.props.active}
        active={this.props.active!}
        disabled={this.props.disabled!}
        aria-disabled={this.props.disabled!}
        focused={this.props.focused!}
        onClick={this.props.onClick}
        data-selector={getDataSelector(this.props.dataSelectorPrefix)}
      >
        <Styled.OverflowMenuItemInnerWrapper>
          {this.props.children && (
            <Styled.IconPlaceholder isIcon={this.checkIsIcon()} group={this.props.children?.props?.group} disabled={this.props.disabled!}>
              {this.props.children}
            </Styled.IconPlaceholder>
          )}
          <Styled.Text data-selector={getDataSelector(this.props.dataSelectorPrefix, 'text')}>{this.props.text}</Styled.Text>
        </Styled.OverflowMenuItemInnerWrapper>
        {this.props.disabled && this.props.helpText && (
          <Styled.DisabledTextContainer hasIcon={!!this.props.children}>
            {this.props.children && <Styled.HiddenIconPlaceholder>{this.props.children}</Styled.HiddenIconPlaceholder>}
            <Styled.Text data-selector={getDataSelector(this.props.dataSelectorPrefix, 'help-text')}>{this.props.helpText}</Styled.Text>
          </Styled.DisabledTextContainer>
        )}
        <Divider noMargin />
      </Styled.OverflowMenuItem>
    )
  }
}

export default OverflowMenuItem
